<template>
        <i @click="close" class="fas fa-times"></i>
        <div class="row"><h3 class="mb-4 col-1 p-0">Поставщик</h3></div>
        <template v-if="item">
        <div class="row border-bottom mb-2 pb-2">
            <div class="col p-0 control-label">Полное наименование</div>
            <div class="col">{{ item.nameFull }}</div>
        </div>
        <div class="row border-bottom mb-2 pb-2" v-if="item.address">
            <div class="col col p-0 control-label">Фактический адрес</div>
            <div class="col">{{ item.address }}</div>
        </div>
        <div class="row border-bottom mb-3 pb-2">
            <div class="col col p-0 control-label">Телефон</div>
            <div class="col">{{ item.phone }}</div>
        </div>
        <div class="row border-bottom mb-3 pb-2">
            <div class="col col p-0 control-label">Факс</div>
            <div class="col">{{ item.fax }}</div>
        </div>
        <div class="row border-bottom mb-3 pb-2">
            <div class="col col p-0 control-label">Электронная почта</div>
            <div class="col">{{ item.email }}</div>
        </div>
        <div class="row border-bottom mb-3 pb-2">
            <div class="col col p-0 control-label">Официальный сайт</div>
            <div class="col">{{ item.www }}</div>
        </div>
        <div class="row border-bottom mb-3 pb-2">
            <div class="col col p-0 control-label">График работы</div>
            <div class="col">{{ item.schedule }}</div>
        </div>
        <div class="row border-bottom mb-3 pb-2">
            <div class="col col p-0 control-label">Руководитель</div>
            <div class="col">{{ item.leaderFio }}</div>
        </div>
        <div class="row border-bottom mb-3 pb-2">
            <div class="col col p-0 control-label">Юридический адрес</div>
            <div class="col">{{ item.addressLegal }}</div>
        </div>
        <div class="row border-bottom mb-3 pb-2">
            <div class="col col p-0 control-label">ОГРН</div>
            <div class="col">{{ item.ogrn }}</div>
        </div>
        <div class="row border-bottom mb-3 pb-2">
            <div class="col col p-0 control-label">ИНН</div>
            <div class="col">{{ item.inn }}</div>
        </div>
        <div class="row border-bottom mb-3 pb-2">
            <div class="col col p-0 control-label">КПП</div>
            <div class="col">{{ item.kpp }}</div>
        </div>

        </template>
</template>
<script>
export default {
    name: "OrgModal",
    props: {
        item: Object
    },
  mounted() {
    console.log(this.item)
  },
  methods: {
        close() {
            this.$emit('close');
        },
    }
}

</script>
<style scoped lang="scss">
.modal-body{
    position: relative;
}

.fa-times {
    position: absolute;
    content: "";
    top: 0;
    right: 0;
}
</style>